import classnames from 'classnames'
import styles from './ProductHeroMobileSlider.module.scss'
import useBreakpoint from '@/hooks/use-breakpoint'
import 'swiper/css'
import Swiper from 'swiper'
import { useEffect, useRef } from 'react'
import SanityImage from '@/components/SanityImage/SanityImage'
import useWindowResize from '@/hooks/use-window-resize'

export const PRODUCT_SLIDER_MOBILE_BREAKPOINTS = {
  xs: {
    width: 700,
  },
}

const ProductHeroMobileSlider = ({ className, images, onInit, setActiveIndex }) => {
  const { isMobile } = useBreakpoint()
  const carouselRef = useRef()
  const resizeKey = useWindowResize()
  const carousel = useRef(null)
  const $container = useRef(null)

  useEffect(() => {
    if (!carouselRef.current) return

    if (carousel.current) {
      carousel.current.destroy()
    }

    if (isMobile) {
      const settings = {
        slidesPerView: 1,
      }

      carousel.current = new Swiper(carouselRef.current, settings)

      carousel.current.on('slideChange', () => {
        setActiveIndex(carousel.current.activeIndex)
      })

      if (onInit) onInit(carousel.current)
    }

    return () => {
      if (carousel.current) {
        carousel.current.destroy()
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resizeKey, isMobile])

  if (!isMobile || isMobile === null) return null

  return (
    <div
      ref={$container}
      className={classnames(styles.ProductHeroMobileSlider, className)}
    >
      <div className={styles.inner}>
        <div
          className={styles.carouselContainer}
          ref={carouselRef}
        >
          <div className={classnames(styles.carouselContainerInner, 'swiper-wrapper')}>
            {images.map((image, i) => {
              return (
                <div
                  className={classnames(styles.imageContainer, 'swiper-slide')}
                  key={i}
                >
                  {isMobile !== null && (
                    <SanityImage
                      className={styles.image}
                      image={image}
                      priority
                      breakpoints={PRODUCT_SLIDER_MOBILE_BREAKPOINTS}
                    />
                  )}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

ProductHeroMobileSlider.displayName = 'ProductHeroMobileSlider'

export default ProductHeroMobileSlider
